module.exports = __webpack_public_path__ + "img/bently.e977ee13.png";